// Two rows of thirty-two is how a 64-bit word is written down everywhere else, so it is how it is written here.
export const BITS_PER_ROW = 32;

export function chunk(indexes: number[], size: number): number[][] {
  const groups: number[][] = [];
  for (let start = 0; start < indexes.length; start += size) groups.push(indexes.slice(start, start + size));
  return groups;
}
